import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { SimpleLoading, PromotionalFooterPure } from "../../pures";
import GridListRequestDetail from "../../pures/configuration-signature-history-detail/grid-list-request-detail.pure";
import "./configuration-signature-history-detail.css";

const ConfigurationSignatureHistoryDetailView = (props) => {
  const { t } = useTranslation();

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    backgroundColor: "white",
    marginBottom: "20px",
    padding: "0px",
    maxWidth: "100%",
    boxShadow: "1px 1px 3px #959595",
    width: "auto",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }
  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
  };

  return (
    <div className="configurationSignatureHistoryDetailView-globalContainerContainer">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="configurationSignatureHistoryDetailView-container"
          >
            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="configurationSignatureHistoryDetailView-header-container"
              >
                <div className="configurationSignatureHistoryDetailView-signers">
                  <h3 className="configurationSignatureHistoryDetailView-title">
                    {t("configurationSignatureHistoryDetailView.signers")}
                  </h3>
                </div>
              </Grid>
              <Grid
                container
                className="configurationSignatureHistoryDetailView-configurations"
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
              >
                <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                  <p className="configurationSignatureHistoryDetailView-labels">
                    {t("configurationSignatureHistoryDetailView.nameRequest")}
                  </p>
                  <p
                    className="configurationSignatureHistoryDetailView-values"
                    name="name"
                  >
                    {props.signRequest.name || ""}
                  </p>
                </Grid>

                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  style={{ marginBottom: "10px" }}
                >
                  <p className="configurationSignatureHistoryDetailView-labels">
                    {t(
                      "configurationSignatureHistoryDetailView.descriptionRequest"
                    )}
                  </p>
                  <p
                    className="configurationSignatureHistoryDetailView-values"
                    name="description"
                  >
                    {props.signRequest.description || ""}
                  </p>
                </Grid>

                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  style={containerTableAndHeadersStyles}
                >
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                    <p className="configurationSignatureHistoryDetailView-labels">
                      {t("configurationSignatureHistoryDetailView.signersGrid")}
                    </p>
                    <GridListRequestDetail {...props} />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="button-back-configuration"
                >
                  <Link
                    to={
                      props.view.route === "index"
                        ? "/configuration-signature-history"
                        : `/${props.view.route}`
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <button
                      onClick={props.scrollWindow}
                      className="configurationSignatureHistoryDetailView-back"
                      style={{ marginLeft: "20px" }}
                    >
                      {t("configurationPanelView.buttonBack")}
                    </button>
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  style={containerTableAndHeadersStyles}
                >
                  <PromotionalFooterPure />
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Container>
      )}
    </div>
  );
};

export { ConfigurationSignatureHistoryDetailView as default };
